import React from 'react';

export default function OkSignIcon() {
  return (
    <span role="img" aria-label="">👌</span>
  );
}
